/**
 * Mutations for the Smart Classifier module.
 * Handles synchronous state updates for intent management.
 */
const mutations = {
  /**
   * Sets the complete intents array.
   *
   * @param {Object} state - Module state
   * @param {Array} intents - Array of intent objects
   */
  SMART_CLASSIFIER_SET_INTENTS: (state, intents) => {
    state.intents = intents;
  },

  /**
   * Adds a new intent to the intents array.
   *
   * @param {Object} state - Module state
   * @param {Object} intent - Intent object to add
   */
  SMART_CLASSIFIER_ADD_NEW_INTENT: (state, intent) => {
    state.intents.push(intent);
  },

  /**
   * Sets the fallback intent name.
   *
   * @param {Object} state - Module state
   * @param {string} fallback - Fallback intent name
   */
  SMART_CLASSIFIER_SET_FALLBACK: (state, fallback) => {
    state.fallback = fallback || "";
  },

  /**
   * Sets the fetching state for loading indicators.
   *
   * @param {Object} state - Module state
   * @param {boolean} isFetching - Whether data is being fetched
   */
  SMART_CLASSIFIER_SET_FETCHING: (state, isFetching) => {
    state.isFetching = isFetching;
  },

  /**
   * Removes an intent by name from the intents array.
   *
   * @param {Object} state - Module state
   * @param {string} intentName - Name of intent to delete
   */
  SMART_CLASSIFIER_DELETE_INTENT: (state, intentName) => {
    const filteredIntents = state.intents.filter((intent) => intent.intentName !== intentName);
    state.intents = filteredIntents;
  },
};

export default mutations;
